import React, {Component} from "react";
import {ATTR_REP_OPT_OBS_SUMMARY, ATTR_REP_OPT_PROJECT_LINK, STR_NO, STR_NO_VALUE, STR_YES} from "./ProsConnect";
import {ProsUpdateInfo, strYesNoValue} from "./ProsCommonUi";
import * as prosConnect from "./ProsConnect";
import Checkbox from "../components/Checkbox";
import Spacer from "../components/Spacer";
import ToggleSwitch from "../components/ToggleSwitch";
import {CancelButton, ConfirmButton} from "../components/BasicButton";
import {setHelpContext} from "./HelpManager";
import BasicModal, {BasicModalDismiss} from "../components/BasicModal";

export default class ProsReportSettingsDialog extends Component {
    constructor(props) {
        super(props);

        const {report} = this.props
        let showObsSummaryEndOfReport = prosConnect.getObjAttr(report, ATTR_REP_OPT_OBS_SUMMARY) === STR_YES
        let showProjectStatistics = prosConnect.getObjAttr(report, ATTR_REP_OPT_PROJECT_LINK) === STR_YES
        let onOffSelections = []
        let textFields = []
        let rbSelections = []
        let project =  prosConnect.getActiveProject()
        this.state = {
            showObsSummaryEndOfReport: showObsSummaryEndOfReport,
            showProjectStatistics: showProjectStatistics,
            onOffSelections: onOffSelections,
            textFields: textFields,
            rbSelections: rbSelections,
        }

        function addTagEnabledForReport(self, report, stag) {
            let tagStr = prosConnect.getObjAttr(report, stag)
            self.state[stag] = tagStr === STR_NO_VALUE || tagStr.includes(STR_YES)
        }

        if (project) {
            for (let i in project.getChTagsS()) {
                let stag = project.getChTagsS()[i]
                onOffSelections.push ({
                    stag: stag,
                    label: project.getChTagLabels()[i],
                })
                addTagEnabledForReport(this, report, stag)
            }
            for (let i in project.getTxtTagsS()) {
                let stag = project.getTxtTagsS()[i]
                textFields.push ({
                    stag: stag,
                    label: project.getTxtLabels()[i],
                })
                addTagEnabledForReport(this, report, stag)
            }
            for (let i in project.getRbTagsS()) {
                let stag = project.getRbTagsS()[i]
                rbSelections.push ({
                    stag: stag,
                    label: project.getRbTagTitles()[i],
                })
                addTagEnabledForReport(this, report, stag)
            }
        }
    }

    renderSelection(stagLabel) {
        const {stag, label} = stagLabel
        return <Checkbox
            text={label}
            checked={this.state[stag]}
            onChange={() => {
                let tagEnabled = {}
                tagEnabled[stag] = !this.state[stag]
                this.setState(tagEnabled)
            }}
            key={stag}
        />
    }

    renderSelections(listName, title) {
        const checkboxlist = this.state[listName].map(stagLabel => {
            return this.renderSelection(stagLabel)
        })
        if(checkboxlist.length < 1) return null
        return <>
            <Spacer size={"lg"}/>
            <h3>{"Raportissa näkyvät " + title}</h3>
            <div className={"selection-group selection-group-check"}>{checkboxlist}</div>
        </>
    }

    renderMainSelection(title, mainSelection) {
        return <ToggleSwitch
            label={title}
            checked={this.state[mainSelection]}
            onChange={()=> {
                let enableObj = {}
                enableObj[mainSelection] = !this.state[mainSelection]
                this.setState(enableObj)
            }}
        />
    }

    // Report settings - label; Y/n depending if show TAG in report
    reportStrYesNo(isEnabled) {
        if (isEnabled) {
            return "x;" + STR_YES
        }
        return "x;" + STR_NO
    }

    saveSelections(report, listName) {
        this.state[listName].forEach( selection =>
           report[selection.stag] = this.reportStrYesNo(this.state[selection.stag])
        )
    }

    async saveReportSettings() {
        let {report} = this.props
        this.saveSelections(report, 'textFields')
        this.saveSelections(report, 'onOffSelections')
        this.saveSelections(report, 'rbSelections')
        report[ATTR_REP_OPT_OBS_SUMMARY] = strYesNoValue(this.state.showObsSummaryEndOfReport);
        report[ATTR_REP_OPT_PROJECT_LINK] = strYesNoValue(this.state.showProjectStatistics);
        // Save to AWS
        await prosConnect.getActiveProject().awaitUpdateItem(report);
    }

    render() {
        let project = prosConnect.getActiveProject()
        const {report} = this.props
        if (!project || !report) {
            return (<h1>Virhe - Ei projektia</h1>)
        }
        return <>
            <section>
                {this.renderMainSelection('Näytä yhteenveto rengaskaaviona', 'showObsSummaryEndOfReport')}
                {this.renderSelections('onOffSelections', 'valinnat')}
                {this.renderSelections('textFields', 'tekstikentät')}
                {this.renderSelections('rbSelections', 'monivalinnat')}
                <ProsUpdateInfo prosObj={report}/>
            </section>
            <footer className={"popup-footer"}>
                <div className={"btn-set"}>
                    <CancelButton
                        action={()=> this.props.closePopUpMenu()}
                    />
                    <ConfirmButton
                        label={"Tallenna"}
                        action={()=> {
                            this.saveReportSettings()
                            this.props.closePopUpMenu()
                        }}
                    />
                </div>
            </footer>
        </>
    }
}

export function OpenReportSettingsBasicModal(params){
    setHelpContext('reportSettings')
    const content = <ProsReportSettingsDialog
        report={params.report}
        closePopUpMenu={BasicModalDismiss}
    />
    BasicModal('Raportin tulostusasetukset', content, {
        hideDismissButton: true
    })
}